import { STORAGE_KEYS } from './constants';

export const RESUME_REDIRECT_WINDOW_MS = 30000;

/**
 * Records that the login page just sent an already-signed-in visitor on, so a bounce straight back is caught.
 */
export const markResumeRedirect = (): void =>
  sessionStorage.setItem(STORAGE_KEYS.RESUME_REDIRECT_AT, String(Date.now()));

/**
 * Whether the login page sent the visitor on within the window - landing here again means they bounced back.
 */
export const hasRecentResumeRedirect = (): boolean => {
  const redirectedAt = sessionStorage.getItem(STORAGE_KEYS.RESUME_REDIRECT_AT);

  if (redirectedAt === null) {
    return false;
  }

  const age = Date.now() - Number(redirectedAt);

  return age >= 0 && age < RESUME_REDIRECT_WINDOW_MS;
};

/**
 * Forgets the last redirect, so it cannot hold back a later legitimate resume.
 */
export const clearResumeRedirect = (): void => sessionStorage.removeItem(STORAGE_KEYS.RESUME_REDIRECT_AT);
